import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import leftArrowIcon from '../Images/right.png';
import rightArrowIcon from '../Images/left.png';
import add from '../Images/add-square.png';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  
  const handleClick = () => {
    navigate('/product', {
      state: { 
        scrollToPromo: true,
        productId: product.id,  // Pass the product.id here
      },
    });
  };
  
  return (
    <div className="flex flex-col items-start bg-white rounded-lg shadow-lg mx-6 md:mx-2 my-2 cursor-pointer " onClick={handleClick} >
<div className="w-full">
        <img src={product.default_image}
    alt={product.name} className="w-full mb-4"
          style={{
            backgroundSize: 'contain', 
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat', 
            aspectRatio: '16 / 14', 
          }}
        />
</div>

      <div className="text-start pl-5 w-full">
        <h3 className="text-md mb-5 mt-3" style={{ fontFamily: 'Arial' }}>{product.name}</h3>
        <div className="flex flex-row items-center justify-between mb-5 mr-3">
          <p className="text-sm" style={{ fontFamily: 'Arial' }}>from £{product.start_price}</p>
          <div className="flex flex-row items-center gap-2">
            <p className="text-sm" style={{ color: '#EC008C', fontFamily: 'Arial' }}>
              Order Now
            </p>
            <button>
              <img src={add} className="w-4 h-4" alt="Add to cart" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Carousel = () => {
  const [products, setProducts] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [arrowClicked, setArrowClicked] = useState(false);
  const [isXLScreen, setIsXLScreen] = useState(window.innerWidth >= 1280);
  const carouselRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('https://backend.printtrio.co.uk/api/product/popular-products', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          const sortedProducts = data.data
            .filter(p => p.is_active === 1) // Optional: only include active products
            .sort((a, b) => a.ordering - b.ordering); // Sort by ordering
  
          setProducts(sortedProducts); // Or .slice(0, 6) if needed
        } else {
          console.error('Failed to fetch products:', data.errors);
        }
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }, []);
  

  const goNext = () => {
    setActiveIndex(prevIndex => (prevIndex + 1) % products.length);
    setArrowClicked(true);
  };

  const goPrev = () => {
    setActiveIndex(prevIndex => (prevIndex === 0 ? products.length - 1 : prevIndex - 1));
    setArrowClicked(true);
  };

  const scrollPrev = () => {
    if (!carouselRef.current) return;
    const card = carouselRef.current.children[0];
    const width = card.getBoundingClientRect().width;
    const gap = 16; // match your `space-x-4`
    carouselRef.current.scrollBy({ left: -(width + gap), behavior: 'smooth' });
  };
  const scrollNext = () => {
    if (!carouselRef.current) return;
    const card = carouselRef.current.children[0];
    const width = card.getBoundingClientRect().width;
    const gap = 16;
    carouselRef.current.scrollBy({ left: width + gap, behavior: 'smooth' });
  };

  const goToProduct = (id) => {
    navigate('/product', { state: { scrollToPromo: true, productId: id } });
  };

  useEffect(() => {
    const handleResize = () => setIsXLScreen(window.innerWidth >= 1280);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (products.length === 0) {
    return <div></div>;
  }

  const visibleProducts = isXLScreen ? [] : [...products];

  if (isXLScreen) {
    const startIndex = activeIndex < 5 ? 0 : activeIndex - 3;
    for (let i = 0; i < 5; i++) {
      visibleProducts.push(products[(startIndex + i) % products.length]);
    }
  }

  const activeVisibleIndex = visibleProducts.findIndex(product => product.id === products[activeIndex]?.id);

  return (
    <div className="bg-white py-12 px-4 md:px-16 xl:px-48 max-w-screen-2xl mx-auto">
      
      
      <h2 className="text-2xl md:text-4xl xl:text-5xl font-semibold mb-14 text-center" style={{ fontFamily: 'arial', color: '#191919' }}>Our Popular Products</h2>
      
        {/* ── Mobile carousel ── */}
      <div className="relative sm:hidden">
      <button
    onClick={scrollPrev}
    className="absolute -left-2 top-1/2 transform -translate-y-1/2 z-10 p-0"
  >
    <img src={leftArrowIcon} alt="Previous" className="w-6 h-6" />
  </button>

        <div
          ref={carouselRef}
          className="flex overflow-x-auto scroll-smooth snap-x snap-mandatory px-0 py-6"
        >
          {products.map(prod => (
            <div
              key={prod.id}
              className="snap-start flex-shrink-0 w-full"
              onClick={() => goToProduct(prod.id)}
            >
              <ProductCard product={prod} />
            </div>
          ))}
        </div>

        <button
    onClick={scrollNext}
    className="absolute -right-4 top-1/2 transform -translate-y-1/2 z-10 p-2"
  >
    <img src={rightArrowIcon} alt="Next" className="w-6 h-6" />
  </button>
      </div>

      {/* ── Desktop grid ── */}
      <div className="relative w-full flex items-center justify-center">
        <button onClick={goPrev} className="hidden xl:inline-flex absolute -left-10 z-10">
          <img src={leftArrowIcon} alt="Previous" className="h-8 w-8" />
        </button>
        <div className="hidden sm:grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-7 xl:gap-0 justify-center snap-x snap-mandatory w-full px-0 md:px-14 xl:px-0">
          {visibleProducts.map((product, index) => (
            <div key={product.id} className={`snap-center transition-transform duration-300 ease-in-out ${arrowClicked && index === activeVisibleIndex ? 'scale-110' : 'scale-100'}`}>
              <ProductCard product={product} />
            </div>
          ))}
        </div>
        <button onClick={goNext} className="hidden xl:inline-flex absolute -right-10 z-10">
          <img src={rightArrowIcon} alt="Next" className="h-8 w-8" />
        </button>
      </div>
    </div>
  );
};

export default Carousel;
